import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2",
  style: {"font-weight":"ligther","font-size":"8pt","color":"green"}
}
const _hoisted_2 = { class: "d-flex justify-center align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_booklet_content = _resolveComponent("booklet-content")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: _ctx.step,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window_item, {
        class: "pb-1",
        value: 0
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            subheader: "",
            class: "d-flex justify-center mt-3",
            style: _normalizeStyle(_ctx.$vuetify.display.mobile ? 'height: 50vh; overflow: auto' : ''),
            lines: "two"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio_group, {
                modelValue: _ctx.selectedTemplate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTemplate) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: item.id,
                      class: _normalizeClass(index === 0 ? 'mt-1 mb-3 oss-list-item' : 'my-1 oss-list-item'),
                      onClick: ($event: any) => (_ctx.selectedTemplate = item)
                    }, {
                      append: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_v_btn_icon, {
                            icon: "$oss-eye",
                            onClick: ($event: any) => {
                                        _ctx.selectedTemplate = item;
                                        _ctx.step = 1;
                                    }
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_v_radio, {
                          key: 'selector:' + item.id,
                          class: "mt-2",
                          value: item
                        }, null, 8, ["value"])),
                        _createVNode(_component_v_list_item_title, {
                          class: "mb-2",
                          style: {"text-overflow":"ellipsis","max-width":"600px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h4", null, _toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_list_item_subtitle, { class: "mb-1" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Proposé par " + _toDisplayString(item.companyScope.accountingCompanyOwner.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_list_item_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getTargets(item.companyScope)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (index === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Recommandé"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, {
        class: "pb-1",
        value: 1
      }, {
        default: _withCtx(() => [
          (_ctx.bundleBookletTemplate)
            ? (_openBlock(), _createBlock(_component_booklet_content, {
                booklet: _ctx.bundleBookletTemplate.content,
                initialBooklet: _ctx.bundleBookletTemplate.content,
                previewMode: true,
                key: _ctx.bundleBookletTemplate.id,
                bundleType: _ctx.bundleType,
                importFilesMillesimfromBundle: _ctx.importFilesMillesimfromBundle,
                onBookletChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setContentToUpsert($event)))
              }, null, 8, ["booklet", "initialBooklet", "bundleType", "importFilesMillesimfromBundle"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}